import { useQuery } from '@tanstack/react-query'
import { GET } from '../../redux/middleware/types'
import deliveryRequest from '../../services/api/deliveryRequest'

interface NotificationHashResponse {
  hash: string
}

const useNotificationHash = (enabled: boolean, userId?: number | string) =>
  useQuery({
    queryKey: [{ scope: 'notifications', entity: 'hash', userId }] as const,
    queryFn: ({ signal }) =>
      deliveryRequest<NotificationHashResponse>({
        method: GET,
        url: '/notifications/hash',
        signal
      }),
    enabled,
    staleTime: Infinity
  })

export default useNotificationHash
